'use strict';

(function() {

  angular
    .module('specsguardApp')
    .controller('ProjectFileManagerCtrl', ProjectFileManagerCtrl);

    ProjectFileManagerCtrl.$inject = ['$scope', 'project',  'Project', 'Labels', 'FileUploader', 'UploadService', 'ProjectDataservice'];

  function ProjectFileManagerCtrl($scope, project, ProjectAPI, Labels, FileUploader, UploadService, ProjectDataservice) {

    const vm = this;
    vm.LABELS = Labels;

    vm.changedFiles = function(allFiles) {
      if (angular.equals(vm.project.uploads, allFiles)) {
        vm.project.uploads = allFiles;
        return;
      }
      allFiles.forEach((file) => {
        const random = Math.random().toString(36).substr(2, 5);
        const name = file.name || file.file.name;

        file.name = `${name}#${random}`;
        return file;
      });

      vm.submitUploads(allFiles);
    };

    // helpers
    vm.submitUploads = (uploads) => {
      const data = {
        project: {
          uploads
        },
        _id: vm.project._id,
        versionId: vm.project.versionId,
      };

      return ProjectAPI.editProject(data).$promise.then((updatedProject) => {
        update({updatedProject, setDataService: true});
      }).catch((x) => {
        console.log(x);
      });
    };

    // sgTable  columns
    vm.tableColumns = [{
      headerTitle: vm.LABELS.getLabel('type'),
      displayKey: 'fileType',
      // type: 'string',
      sortable: true,
      columnFilter: true,
      template: 'app-legacy/project/filemanager/filemanager.type.template.html',
    }, {
      headerTitle: vm.LABELS.getLabel('name'),
      displayKey: 'name',
      sortable: true,
      columnFilter: true,
    }, {
      headerTitle: 'size',
      displayKey: 'fileSize',
      sortable: true,
      columnFilter: true,
    }, {
      headerTitle: '',
      tdClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      thClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      template: 'app-legacy/project/filemanager/filemanager.options.template.html',
      columnFilter: true,
    }];

    vm.pagination = {
      resultLimitDropdown: {
        enabled: true,
        limit: [10, 20, 50, 100, 250, 500]
      },
      resultLimit: 10
    };

    vm.columnFilters = {
      enabled: true,
    };

    /**
     * removeFile
     * removes file from the scope and also updates the project data
     */
    vm.removeFile = (file) => {
      vm.project.uploads = vm.project.uploads.filter((upload) => upload._id !== file._id);
      vm.submitUploads(vm.project.uploads);
    };

    vm.downloadFile = (item) => {
      window.open(item.path, '_blank');
    };

    const setFileName = () => {
      vm.project.uploads.filter((item) => {
        return item.name = formatFileName(item.file.name);
      });
    };

    // WIP: Based on file type we will display an icon tpye
    const setFileType = () => {
      vm.project.uploads.filter((item) => {
        const type = item.file.type.substr((item.file.type.lastIndexOf('/') + 1));

        switch (type) {
          case 'jpeg':
          case 'jpg':
          case 'gif':
          case 'png':
            item.fileType = 'image';
            break;
          case 'pdf':
            item.fileType = 'picture_as_pdf';
            break;
          default:
            item.fileType = 'attachment';
        }

        return item;
      });
    };

    // WIP: Filesize should be readable
    const setFileSize = () => {
      vm.project.uploads.filter((item) => {
        return item.fileSize = formatFileSize(item.file.size);
      });
    };

    /**
     * Clean up file name to only
     */
    const formatFileName = (name) => {
      return name.replace(/(\.[^/.]+)+$/, '');
    };

    /**
     * Format the file size of each item
     */

    const formatFileSize = (size, decimals = 2) => {
      if (size === 0) {
        return '0 Bytes';
      }

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB'];

      const i = Math.floor(Math.log(size) / Math.log(k));
      return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    function update({updatedProject, setDataService}) {
      vm.project = updatedProject;
      setFileName();
      setFileType();
      setFileSize();

      if (setDataService) {
        ProjectDataservice.setProjectById(updatedProject._id, updatedProject);
      }
    }

    update({updatedProject: project, setDataService: false});
  }
})();
